import { guardNumber } from "../numbers";
import type { Nullable } from "../types";

export function calculateSquareMeters<
	T extends {
		length?: Nullable<number>;
		width?: Nullable<number>;
	},
>(item: T): number {
	const length = Math.max(0, guardNumber(item.length));
	const width = Math.max(0, guardNumber(item.width));
	return length * width;
}
